"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const LinkEntity_1 = require("../../common/model/LinkEntity");
const SchoolsConverter_1 = require("../SchoolsConverter");
class ApiSchoolsClient extends ApiSubClient_1.ApiSubClient {
    searchUsaSchools(state, query) {
        const getThemesLink = new LinkEntity_1.Link(this.getLinkOrThrow('searchSchools'));
        return this.axios
            .get(getThemesLink.getTemplatedLink({
            state: state,
            query: query,
        }))
            .then((response) => SchoolsConverter_1.SchoolsConverter.convert(response));
    }
}
exports.default = ApiSchoolsClient;
//# sourceMappingURL=ApiSchoolsClient.js.map